'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _components = require('components');

var _Navigation = require('components/Navigation');

var _Mobile = require('components/Mobile');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _styles = require('../../../static/sass/styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise() {
    return _promise2.default.resolve();
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang, nextLanguage: state.language.nextLang };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(languageActions, dispatch);
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this.addExtraMetadata = function (actualLang, otherLang, actualPath, headProps) {
      if (typeof headProps !== 'undefined') {
        headProps.link = [{ 'rel': 'canonical', 'href': _config2.default.baseUrl + actualPath }, { 'rel': 'alternate', 'href': _config2.default.baseUrl + actualPath, 'hrefLang': actualLang }, { 'rel': 'alternate', 'href': _config2.default.baseUrl + actualPath.replace("/" + actualLang + "/", "/" + otherLang + "/"), 'hrefLang': otherLang }];
        headProps.htmlAttributes = { 'xmlns': 'http://www.w3.org/1999/xhtml', 'xmlLang': actualLang, 'lang': actualLang, 'xmlns:og': 'http://ogp.me/ns#', 'xmlns:fb': 'http://ogp.me/ns/fb#' };
      }

      return headProps;
    };

    _this.changeLanguage = function () {
      _this.props.changeLanguage(_this.props.currentLanguage, _this.props.location, _reactRouter.browserHistory);
    };

    _this.getUrlNextLang = function () {
      var actualLang = _this.props.currentLanguage;
      var location = _this.props.location;

      var newLang = actualLang === 'es' ? 'en' : 'es';
      var nextUrl = location.pathname;

      /*Separamos url en un array por '/' y limpiamos los vacíos para obtener el último pathname*/
      nextUrl = nextUrl.replace('/' + actualLang + '/', '/' + newLang + '/');
      if (typeof newPath !== "undefined") {
        nextUrl = nextUrl.replace('/' + actualPath + '/', '/' + newPath + '/');
      }

      return nextUrl;
    };

    _this.toggleMute = function () {
      _this.refs.sidebar.toggleMute();
    };

    _this.setMute = function (muteOn) {
      if (_this.refs != undefined) {
        _this.refs.sidebar.setMute(muteOn);
      }
    };

    _this.exitTab = function () {
      _this.refs.sidebar.exitTab();
    };

    _this.state = {
      inTab: true
    };
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        baseUrl: _config2.default.baseUrl,
        project: _config2.default.project,
        toggleMute: this.toggleMute,
        exitTab: this.exitTab,
        setMute: this.setMute
      };
    }
  }, {
    key: 'showHideCaption',
    value: function showHideCaption() {
      if (true) {
        $('#video').get(0).textTracks[this.context.lang].mode = "showing";
        $('#video').get(0).textTracks[Number(!this.context.lang)].mode = "hidden";
      } else {
        $('#video').get(0).textTracks[this.context.lang].mode = "hidden";
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      document.addEventListener('visibilitychange', function (e) {
        e.preventDefault();
        //console.log('change tab');

        if (document.getElementsByClassName('icon-mute')[0]) {
          //comprobamos q esté sonando, cuando el icono está en mute kiere decir q la musica se está reproduciendo

          if (self.state.inTab) {
            //se va de la pag
            //console.log('fuera de la tab')
            self.setState({
              inTab: false
            });

            self.exitTab();
          } else {
            //entra, seteamos inTab a true        
            //console.log('dentro de la tab')
            self.setState({
              inTab: true
            });

            self.setMute(false);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {

      //const styles = require('../../../static/sass/styles.scss');

      var actualPath = this.props.location.pathname.replace(_config2.default.project + '/', ''); //Le quitamos al pathname la parte correspondiente al proyecto existente sólo en cliente
      var lang = this.props.currentLanguage;
      var nextLang = this.props.nextLanguage;
      var headProps = _config2.default.app.head[actualPath];
      var headPropsComplete = this.addExtraMetadata(lang, nextLang, actualPath, headProps);
      var twTxt = encodeURI(headProps.twitterText);
      var urlShare = '';

      (0, _getOwnPropertyNames2.default)(headProps.meta).forEach(function (val, idx, array) {
        if (headProps.meta[val].property == 'og:url') {
          urlShare = headProps.meta[val].content;
        }
      });

      /*Para el share de mobile, comparte siempre la portada*/
      var actualPathMobile = '/' + lang + '/';
      var headPropsMobile = _config2.default.app.head[actualPathMobile];
      var headPropsCompleteMobile = this.addExtraMetadata(lang, nextLang, actualPathMobile, headPropsMobile);
      var twTxtMobile = encodeURI(headPropsMobile.twitterText);
      var urlShareMobile = '';

      (0, _getOwnPropertyNames2.default)(headPropsMobile.meta).forEach(function (val, idx, array) {
        if (headPropsMobile.meta[val].property == 'og:url') {
          urlShareMobile = headPropsMobile.meta[val].content;
        }
      });

      var urlNextLang = this.getUrlNextLang();

      //urlNextLang = urlNextLang.replace(config.project + '/', '')

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.app },
        _react2.default.createElement(_reactHelmet2.default, headPropsComplete),
        _react2.default.createElement(
          'header',
          { className: 'main-header' },
          _react2.default.createElement(
            _reactRouter.IndexLink,
            { to: _config2.default.baseUrl + "/" + this.props.currentLanguage + "/", className: 'homeLink' },
            _react2.default.createElement('div', { className: _styles2.default.brand }),
            _react2.default.createElement(
              'span',
              null,
              _config2.default.app.title
            )
          ),
          _react2.default.createElement(_components.Menu, { currentLanguage: lang })
        ),
        _react2.default.createElement(
          'main',
          null,
          _react2.default.createElement(_Navigation.Sidebar, { ref: 'sidebar', nextLanguage: nextLang, changeLanguage: this.changeLanguage, urlNextLang: urlNextLang, twTxt: twTxt, urlShare: urlShare }),
          _react2.default.createElement(
            'div',
            { className: 'mainContent', key: "path-" + actualPath },
            this.props.children
          ),
          _react2.default.createElement(_Mobile.Mobile, { connectedTime: 4500, twTxt: twTxtMobile, urlShare: urlShareMobile, currentLanguage: lang })
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.displayName = 'App', _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  changeLanguage: _react.PropTypes.func,
  setLangFromUrl: _react.PropTypes.func,
  location: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _class2.childContextTypes = {
  baseUrl: _react.PropTypes.string,
  project: _react.PropTypes.string,
  toggleMute: _react.PropTypes.func,
  setMute: _react.PropTypes.func,
  exitTab: _react.PropTypes.func,
  showFade: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 811
// module chunks = 0